import {z} from "zod";

export const Flavor = z.union([z.literal("SMALOX"), z.literal("BOXLOX"), z.literal("DAYLOX")]);
export type Flavor = z.infer<typeof Flavor>;

/**
 * Wording flavor for translations. Used to resolve flavor-specific translation keys.
 * - "default": Standard locker terminology (used by smalox and daylox)
 * - "boxlox": Shipping box terminology (used by boxlox)
 */
export type WordingFlavor = "default" | "boxlox";

export function getFlavor(): Flavor {
	if (location.hostname.includes("boxlox") || location.search.includes("boxlox")) {
		return "BOXLOX";
	}
	if (location.hostname.includes("daylox") || location.search.includes("daylox")) {
		return "DAYLOX";
	}
	return "SMALOX";
}

/**
 * Returns the wording flavor based on the current flavor.
 * - smalox and daylox use "default" wording (standard locker terminology)
 * - boxlox uses "boxlox" wording (shipping box terminology)
 */
export function getWordingFlavor(): WordingFlavor {
	const flavor = getFlavor();
	return flavor === "BOXLOX" ? "boxlox" : "default";
}

/**
 * Returns the deployment stage based on the hostname.
 */
export type Stage = "localhost" | "dev" | "test" | "production";

export function getStage(): Stage {
	if (location.hostname === "localhost") {
		return "localhost";
	}
	if (location.hostname.includes("-dev.")) {
		return "dev";
	}
	if (location.hostname.includes("-test.")) {
		return "test";
	}
	return "production";
}
